import { Component, OnInit } from "@angular/core";

import * as AOS from "aos";

@Component({
  selector: "app-tour",
  templateUrl: "./tour.component.html",
  styleUrls: ["./tour.component.scss"]
})
export class TourComponent implements OnInit {
  constructor() {}

  ngOnInit() {
    AOS.init();
  }
}
